
import { Realm } from '@/model';
import realms from '@/store/realms';
import Vue from 'vue';

export default Vue.extend({
  name: 'RealmPicker',
  props: {
    value: { type: [Object, Array] as any as () => Realm | Array<Realm> | undefined, required: false },
    pickDefault: { type: Boolean, default: false },
    icon: { type: String },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    items(): Realm[] {
      return [...realms.state.realms];
    },
    id(): number | number[] | undefined {
      return Array.isArray(this.value) ? this.value.map((v) => v.id) : this.value?.id;
    },
    multiple(): boolean {
      return Array.isArray(this.value);
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(value: Realm | Array<Realm> | undefined) {
        if (this.empty(value) && this.pickDefault && realms.getters.main) {
          this.input(this.multiple ? [realms.getters.main] : realms.getters.main);
        }
      },
    },
  },

  methods: {
    input(v: number | number[] | undefined) {
      if (Array.isArray(v)) {
        this.$emit('input', v.map((r) => realms.getters.lookup.get(r)));
      } else {
        this.$emit('input', v ? realms.getters.lookup.get(v) : undefined);
      }
    },
    empty(value: Realm | Array<Realm> | undefined): boolean {
      if (Array.isArray(value)) {
        return value.length <= 0;
      }
      return value === undefined;
    },
    name(realm: Realm) {
      return realm.name;
    },
  },
});
